import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response';
import { LicenceValidationLog } from '../../models/licence-validation-log';

@Injectable({ providedIn: 'root' })
export class ValidationLogsService {
  constructor(private http: HttpClient) {}

  getLogs(
    page: number,
    size: number,
    organizationId: string,
    wasSuccessful: string,
    search: string
  ): Observable<ApiResponse<LicenceValidationLog[]>> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (organizationId.trim()) {
      params = params.set('organizationId', organizationId.trim());
    }

    if (wasSuccessful !== '') {
      params = params.set('wasSuccessful', wasSuccessful);
    }

    if (search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<ApiResponse<LicenceValidationLog[]>>(
      `${environment.apiBaseUrl}/admin/licence-validation-logs`,
      { params }
    );
  }
}